import { Link } from 'react-router-dom'
import { ArrowLeft, Home } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-ivory px-4 py-20">
      <div className="max-w-lg text-center">
        <p className="eyebrow">Fuera de bounds</p>
        <p className="mt-4 font-serif text-8xl text-fairway">404</p>
        <h1 className="mt-4 font-serif text-3xl text-ink">Esta página se fue al rough.</h1>
        <p className="mt-4 text-mist">
          No te preocupes: te ayudamos a volver al fairway.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/" className="btn-primary">
            <Home className="h-4 w-4" />
            Ir al inicio
          </Link>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 rounded-full border border-fairway/20 px-6 py-3 text-sm font-semibold text-fairway hover:bg-cream"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
